<template>
  <widget-field-checkbox
    :model-value="modelValueOverride ?? fieldProps.modelValue.value"
    :has-error="fieldProps.hasError.value"
    :error-message="fieldProps.errorMessage.value"
    :readonly="fieldProps.readonly"
    :align-top="alignTop"
    @update:model-value="fieldProps.onUpdate"
    @blur="fieldProps.onBlur"
  >
    <slot />
  </widget-field-checkbox>
</template>

<script setup lang="ts">
import { getReactiveWidgetFieldProps } from '@widgets/shared/compositions/field'
import type { WidgetFormFieldProps } from '@widgets/shared/components/fields/types'
import WidgetFieldCheckbox, {
  type WidgetFieldCheckboxExtraProps,
} from '@widgets/shared/components/fields/WidgetFieldCheckbox.vue'

const props = defineProps<WidgetFormFieldProps & WidgetFieldCheckboxExtraProps>()

const fieldProps = getReactiveWidgetFieldProps<boolean>(props.name)
</script>
